import React from 'react';
import Avatar from '../ui/Avatar';
import LevelBadge from './LevelBadge';
import XPBar from './XPBar';
import Streak from './Streak';
import './PlayerHeader.css';

// The persistent player-identity block: Avatar → Level → XP → Streak, in
// that order, per docs/UI_UX_ARCHITECTURE.md §2. `progress` is the exact
// shape GET /portal/player-profile returns; `progress === null` renders an
// honest loading skeleton rather than guessing at zeros.
const PlayerHeader = ({ name, avatarId, progress, onAvatarClick }) => (
  <div className="z-player-header">
    <button
      type="button"
      className="z-player-header-avatar-btn"
      onClick={onAvatarClick}
      aria-label={onAvatarClick ? 'Change your avatar' : undefined}
      disabled={!onAvatarClick}
    >
      <Avatar avatarId={avatarId} name={name} size="lg" ring />
    </button>

    <div className="z-player-header-body">
      <div className="z-player-header-toprow">
        <h2 className="z-player-header-name">{name}</h2>
        {progress && <LevelBadge level={progress.level} size="sm" />}
      </div>

      {progress ? (
        <>
          <XPBar levelProgress={progress.levelProgress} compact />
          <div className="z-player-header-streak">
            <Streak streak={progress.streak} compact />
          </div>
        </>
      ) : (
        <div className="z-player-header-skeleton" aria-hidden="true" />
      )}
    </div>
  </div>
);

export default PlayerHeader;
